import _objectDestructuringEmpty from "/app/node_modules/babel-runtime/helpers/objectDestructuringEmpty";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import { DashboardApi, CollectorsApi, AffiliationApi } from "~/api";
import moment from "moment";
import { RoleEnum } from "@affiliation/enums";

var setTableParametersOfState = function setTableParametersOfState(state, data) {
  return {
    idProduct: data.type == "Process" ? state.affiliationsProcessData.filter.idProduct : state.affiliationsWorkedData.filter.idProduct || -1,
    admisionStartDate: data.type == "Process" ? state.affiliationsProcessData.filter.admisionStartDate : state.affiliationsWorkedData.filter.admisionStartDate || "",
    admisionEndDate: data.type == "Process" ? state.affiliationsProcessData.filter.admisionEndDate : state.affiliationsWorkedData.filter.admisionEndDate || "",
    highStartDate: data.type == "Process" ? state.affiliationsProcessData.filter.highStartDate : state.affiliationsWorkedData.filter.highStartDate || "",
    highEndDate: data.type == "Process" ? state.affiliationsProcessData.filter.highEndDate : state.affiliationsWorkedData.filter.highEndDate || "",
    status: data.type == "Process" ? state.affiliationsProcessData.filter.status : state.affiliationsWorkedData.filter.status || -1,
    idDepartament: data.type == "Process" ? state.affiliationsProcessData.filter.idDepartament : state.affiliationsWorkedData.filter.idDepartament || -1,
    idProvince: data.type == "Process" ? state.affiliationsProcessData.filter.idProvince : state.affiliationsWorkedData.filter.idProvince || -1,
    idDistrict: data.type == "Process" ? state.affiliationsProcessData.filter.idDistrict : state.affiliationsWorkedData.filter.idDistrict || -1,
    osvCommercialCode: "",
    step: data.type == "Process" ? state.affiliationsProcessData.filter.step : state.affiliationsWorkedData.filter.step || -1,
    offset: data.limit * (data.paginationNumber - 1) || 0,
    limit: data.limit || 10
  };
};

var date = {
  year: parseInt(moment().format("YYYY"), 10),
  month: parseInt(moment().format("M"), 10)
};

export var state = function state() {
  return {
    dataCollection: {
      labels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      datasets: [{
        backgroundColor: "#3490e7",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }]
    },
    donutData: {
      datasets: [{
        data: [0, 0, 0, 0, 0],
        backgroundColor: ["#3490e7", "#0087EE", "#00B0FF", "#0079C7", "#003F94"],
        borderWidth: 0,
        borderColor: "#ffffff"
      }]
    },
    posFijo: 0,
    pagoApp: 0,
    pagoLink: 0,
    pagoWeb: 0,
    posInalam: 0,
    beforeAffiliations: 0,
    currentAffiliations: 0,
    notConcretedCurrent: 0,
    notConcretedBefore: 0,
    processTotal: 0,
    // mJanuary  : 0,
    // mFebruary : 0,
    // mMarch : 0,
    // mApril : 0,
    // mMay : 0,
    // mJune : 0,
    // mJuly : 0,
    // mAugust : 0,
    // mSeptember : 0,
    // mOctober : 0,
    // mNovember : 0,
    // mDecember : 0,
    graphicData: [],
    affiliationsProcess: [],
    affiliationsWorked: [],
    affiliationsRanking: [],
    emptyTable: true,
    affiliationsProcessData: {
      totalItems: 0,
      pageNumber: 1,
      pageSize: 10,
      filter: {
        idProduct: -1,
        admisionStartDate: "",
        admisionEndDate: "",
        highStartDate: "",
        highEndDate: "",
        status: -1,
        idDepartament: -1,
        idProvince: -1,
        idDistrict: -1,
        step: -1
      }
    },
    affiliationsWorkedData: {
      totalItems: 0,
      pageNumber: 1,
      pageSize: 10,
      filter: {
        idProduct: -1,
        admisionStartDate: "",
        admisionEndDate: "",
        highStartDate: "",
        highEndDate: "",
        status: -1,
        idDepartament: -1,
        idProvince: -1,
        idDistrict: -1,
        step: -1
      }
    },
    rankingData: {
      totalItems: 0,
      pageNumber: 1,
      pageSize: 10,
      filter: ""
    },
    pageSize: 10,
    pageNumber: 1,
    search: {
      term: ""
    },
    product: null,
    status: null,
    sinceDate: null,
    toDate: null,
    monthYear: null,
    removeFilter: true,
    pagination: {
      page: 1
    },
    TotalItemsWork: 0,
    TotalItemsProcess: 0,
    TotalItemsRanking: 0
  };
};
export var getters = {
  chartDataset: function chartDataset(state, getter) {
    return {
      dataCollection: state.dataCollection
    };
  },
  totalItemsProcess: function totalItemsProcess(state) {
    var totalItems = parseInt(state.TotalItemsProcess / state.pageSize, 10) + (state.TotalItemsProcess % state.pageSize > 0 ? 1 : 0);
    return totalItems === 0 ? 1 : totalItems;
  },
  totalItemsWork: function totalItemsWork(state) {
    var totalItems = parseInt(state.TotalItemsWork / state.pageSize, 10) + (state.TotalItemsWork % state.pageSize > 0 ? 1 : 0, 10);
    return totalItems === 0 ? 1 : totalItems;
  },
  totalItemsRanking: function totalItemsRanking(state) {
    var totalItems = parseInt(state.TotalItemsRanking / state.pageSize, 10) + (state.TotalItemsRanking % state.pageSize > 0 ? 1 : 0, 10);
    return totalItems === 0 ? 1 : totalItems;
  },
  beforeAffiliations: function beforeAffiliations(state) {
    return state.beforeAffiliations;
  },
  currentAffiliations: function currentAffiliations(state) {
    return state.currentAffiliations;
  },
  notConcretedCurrent: function notConcretedCurrent(state) {
    return state.notConcretedCurrent;
  },
  notConcretedBefore: function notConcretedBefore(state) {
    return state.notConcretedBefore;
  },
  processTotal: function processTotal(state) {
    return state.processTotal;
  }

  //GRAFICO PIE
  // posFijo: state => state.posFijo,
  // pagoApp: state => state.pagoApp,
  // pagoLink: state => state.pagoLink,
  // pagoWeb: state => state.pagoWeb,
  // posInalam: state => state.posInalam,
  //Grafico BARRAS

  // mJanuary: state=> state.mJanuary ,
  // mFebruary: state=> state.mFebruary,
  // mMarch: state=> state.mMarch,
  // mApril: state=> state.mApril,
  // mMay: state=> state.mMay,
  // mJune: state=> state.mJune,
  // mJuly: state=> state.mJuly,
  // mAugust: state=> state.mAugust,
  // mSeptember: state=> state.mSeptember,
  // mOctober: state=> state.mOctober,
  // mNovember: state=> state.mNovember,
  // mDecember: state=> state.mDecember,
};

export var mutations = {
  tableResponsiveData: function tableResponsiveData(state, val) {
    // state.dashboard.table.affiliationsWorked = val
    state.affiliationsWorked.push(val);
  },
  setPageSize: function setPageSize(state, pageSize) {
    state.pageSize = pageSize;
  },
  removeFilter: function removeFilter(state, val) {
    state.affiliationsProcess = state.affiliationsProcess.concat(val.updateItems);
  },
  updateList: function updateList(state, val) {
    state.removeFilter = val.filter;
  },
  updateItemsRanking: function updateItemsRanking(state, val) {
    state.affiliations.ranking.items = state.affiliations.ranking.items.concat(val.updateItemsRanking);
  },
  setAffiliations: function setAffiliations(state, _ref) {
    var affiliations = _ref.affiliations,
        noContent = _ref.noContent;

    if (noContent) {
      // state.affiliations = {
      //     items: [],
      //     total: 0,
      //     noContent: true
      // }
      state.pageNumber = 1;
      return;
    }

    if (state.affiliations.total !== affiliations.total && !state.isSaving) {
      state.pageNumber = 1;
    }

    state.affiliations = _extends({}, affiliations, { noContent: false });
  },

  // setSearch(state, search) {
  //     state.pageNumber = 1
  //     state.search = search
  // },
  setIsSaving: function setIsSaving(state, isSaving) {
    state.isSaving = isSaving;
  },
  setDashboardFilters: function setDashboardFilters(state, _ref2) {
    var product = _ref2.product,
        status = _ref2.status,
        sinceDate = _ref2.sinceDate,
        toDate = _ref2.toDate,
        monthYear = _ref2.monthYear;

    state.product = product;
    state.status = status;
    state.sinceDate = sinceDate;
    state.toDate = toDate;
    state.monthYear = monthYear;
    state.pagination.page = 1;
  },
  setGraphicData: function setGraphicData(state, data) {
    state.graphicData = data;
    var dasboard = state.graphicData[0][0];
    state.beforeAffiliations = dasboard.concretedBeforeTotal;
    state.currentAffiliations = dasboard.concretedCurrentTotal;
    state.notConcretedCurrent = dasboard.notConcretedCurrentTotal;
    state.notConcretedBefore = dasboard.notConcretedBeforeTotal;
    state.processTotal = dasboard.processTotal;
    //GRAFICO PIE

    state.posFijo = isNaN(parseInt(dasboard.POSFijo, 10)) ? 0 : parseInt(dasboard.POSFijo, 10);
    state.pagoApp = isNaN(parseInt(dasboard.PagoAPP, 10)) ? 0 : parseInt(dasboard.PagoAPP, 10);
    state.pagoLink = isNaN(parseInt(dasboard.PagoLink, 10)) ? 0 : parseInt(dasboard.PagoLink, 10);
    state.posInalam = isNaN(parseInt(dasboard.PosInalam, 10)) ? 0 : parseInt(dasboard.PosInalam, 10);
    state.pagoWeb = isNaN(parseInt(dasboard.PagoWEB, 10)) ? 0 : parseInt(dasboard.PagoWEB, 10);

    state.donutData = {
      datasets: [{
        data: [state.posInalam, state.posFijo, state.pagoWeb, state.pagoApp, state.pagoLink],
        backgroundColor: ["#3490e7", "#0087EE", "#00B0FF", "#0079C7", "#003F94"],
        borderWidth: 0,
        borderColor: "#ffffff"
      }]
    };

    state.dataCollection = {
      labels: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      datasets: [{
        backgroundColor: "#3490e7",
        data: [dasboard.january, dasboard.february, dasboard.march, dasboard.april, dasboard.may, dasboard.june, dasboard.july, dasboard.august, dasboard.september, dasboard.october, dasboard.november, dasboard.december]
      }]
    };
  },
  setTableProcessData: function setTableProcessData(state, data) {
    var items = data[0];
    state.affiliationsProcess = items;
    state.TotalItemsProcess = parseInt(items.length && items[0].CountRecord, 10);
  },
  setTableProcessDataLazyLoad: function setTableProcessDataLazyLoad(state, data) {
    var items = data[0];
    state.affiliationsProcess = items;
    //state.TotalItemsProcess = parseInt(items.length && items[0].CountRecord)
  },
  setTableWorkData: function setTableWorkData(state, data) {
    var items = data[0];
    state.affiliationsWorked = items;
    state.TotalItemsWork = parseInt(items.length && items[0].CountRecord, 10);
  },
  setTableRanking: function setTableRanking(state, data) {
    state.affiliationsRanking = data[0];
    if (state.affiliationsRanking.length > 0) {
      state.emptyTable = false;
    } else {
      state.emptyTable = true;
    }
  },
  setPagination: function setPagination(state, _ref3) {
    var pageNumber = _ref3.pageNumber,
        pageSize = _ref3.pageSize;

    state.pageNumber = state.pageSize !== pageSize ? 1 : pageNumber;
    state.pageSize = pageSize;
  },
  setTerm: function setTerm(state, data) {
    state.search.term = data;
  },
  setDataFilter: function setDataFilter(state, data) {
    var conditional = data.type == "Process" ? state.affiliationsProcessData : state.affiliationsWorkedData;
    conditional.filter.idProduct = data.idProduct;
    conditional.filter.admisionStartDate = data.admisionStartDate;
    conditional.filter.admisionEndDate = data.admisionEndDate;
    conditional.filter.highStartDate = data.highStartDate;
    conditional.filter.highEndDate = data.highEndDate;
    conditional.filter.status = data.status;
    conditional.filter.idDepartament = data.idDepartament;
    conditional.filter.idProvince = data.idProvince;
    conditional.filter.idDistrict = data.idDistrict;
    conditional.filter.step = data.step;
    conditional.filter.CommerceCodeUSD = data.CommerceCodeUSD;
    conditional.filter.CommerceCodePEN = data.CommerceCodePEN;
  },
  cleanSetData: function cleanSetData(state, data) {
    var conditional = data == "Process" ? state.affiliationsProcessData : state.affiliationsWorkedData;
    conditional.filter.idProduct = -1;
    conditional.filter.admisionStartDate = "";
    conditional.filter.admisionEndDate = "";
    conditional.filter.highStartDate = "";
    conditional.filter.highEndDate = "";
    conditional.filter.status = -1;
    conditional.filter.idDepartament = -1;
    conditional.filter.idProvince = -1;
    conditional.filter.idDistrict = -1;
    conditional.filter.step = -1;
    conditional.filter.CommerceCodeUSD = -1;
    conditional.filter.CommerceCodePEN = -1;
  }
};

export var actions = {
  getDashboardData: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4, idRole) {
      var dispatch = _ref4.dispatch,
          rootState = _ref4.rootState;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = idRole || rootState.user.roleId;
              _context.next = _context.t0 === 1 ? 3 : _context.t0 === 2 ? 3 : _context.t0 === 3 ? 6 : 9;
              break;

            case 3:
              _context.next = 5;
              return _Promise.all([
              // dispatch('getGraphicAdmin', {}),
              dispatch("getTableProcessAdmin", {}), dispatch("getTableWorkAdmin", {})
              // dispatch('getTableRanking', {}),
              ]);

            case 5:
              return _context.abrupt("break", 11);

            case 6:
              _context.next = 8;
              return _Promise.all([
              // dispatch('getGraphicSupervisor', {}),
              dispatch("getTableProcessSupervisor", {}), dispatch("getTableWorkSupervisor", {})
              // dispatch('getTableRanking', {}),
              ]);

            case 8:
              return _context.abrupt("break", 11);

            case 9:
              _context.next = 11;
              return _Promise.all([
              // dispatch('getGraphicSeller', {}),
              dispatch("getTableProcessSeller", {}), dispatch("getTableWorkSeller", {})]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getDashboardData(_x, _x2) {
      return _ref5.apply(this, arguments);
    }

    return getDashboardData;
  }(),
  search: function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6, data) {
      var rootState = _ref6.rootState,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = rootState.user.roleId;
              _context2.next = _context2.t0 === 1 ? 3 : _context2.t0 === 2 ? 3 : _context2.t0 === 3 ? 5 : 7;
              break;

            case 3:
              dispatch("getTable" + data.type + "Admin", data);
              return _context2.abrupt("break", 8);

            case 5:
              dispatch("getTable" + data.type + "Supervisor", data);
              return _context2.abrupt("break", 8);

            case 7:
              dispatch("getTable" + data.type + "Seller", data);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function search(_x3, _x4) {
      return _ref7.apply(this, arguments);
    }

    return search;
  }(),
  getTableRanking: function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref8, data) {
      var commit = _ref8.commit,
          rootState = _ref8.rootState;
      var response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return new DashboardApi(this.$axios).getTableRanking({
                idChannel: data.idChannel || -1,
                idTeam: rootState.user.idTeam || -1,
                idSeller: data.idSeller || -1,
                limit: data.limit || 10,
                offset: data.limit * (data.paginationNumber - 1) || 0
              });

            case 2:
              response = _context3.sent;

              commit("setTableRanking", response);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getTableRanking(_x5, _x6) {
      return _ref9.apply(this, arguments);
    }

    return getTableRanking;
  }(),
  getGraphicAdmin: function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref10, _ref11) {
      var commit = _ref10.commit,
          rootState = _ref10.rootState;
      var idChannel = _ref11.idChannel,
          idSeller = _ref11.idSeller;
      var conditional, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              conditional = RoleEnum.SUPER_ADMIN === true ? rootState.user.idTeam : -1;
              _context4.next = 3;
              return new DashboardApi(this.$axios).getGraphicAdmin(_extends({
                idChannel: idChannel || -1,
                idTeam: conditional || -1,
                idSeller: idSeller || -1
              }, date));

            case 3:
              response = _context4.sent;

              commit("setGraphicData", response);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getGraphicAdmin(_x7, _x8) {
      return _ref12.apply(this, arguments);
    }

    return getGraphicAdmin;
  }(),
  getGraphicSupervisor: function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref13, _ref14) {
      var commit = _ref13.commit,
          rootState = _ref13.rootState;
      var idSeller = _ref14.idSeller;
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new DashboardApi(this.$axios).getGraphicSupervisor(_extends({
                idTeam: rootState.user.idTeam || -1,
                idSeller: idSeller || -1
              }, date));

            case 2:
              response = _context5.sent;

              commit("setGraphicData", response);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getGraphicSupervisor(_x9, _x10) {
      return _ref15.apply(this, arguments);
    }

    return getGraphicSupervisor;
  }(),
  getGraphicSeller: function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref16, _ref17) {
      var commit = _ref16.commit,
          rootState = _ref16.rootState;
      var idSeller = _ref17.idSeller;
      var response;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return new DashboardApi(this.$axios).getGraphicSeller(_extends({
                idSeller: rootState.user.userId || -1
              }, date));

            case 2:
              response = _context6.sent;

              commit("setGraphicData", response);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function getGraphicSeller(_x11, _x12) {
      return _ref18.apply(this, arguments);
    }

    return getGraphicSeller;
  }(),
  getTableProcessAdmin: function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref19, data) {
      var commit = _ref19.commit,
          rootState = _ref19.rootState,
          state = _ref19.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return new DashboardApi(this.$axios).getTableProcessAdmin(_extends({
                idChannel: data.idChannel || -1,
                idTeam: data.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context7.sent;

              commit("setTableProcessData", response);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getTableProcessAdmin(_x13, _x14) {
      return _ref20.apply(this, arguments);
    }

    return getTableProcessAdmin;
  }(),
  getTableWorkAdmin: function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref21, data) {
      var commit = _ref21.commit,
          rootState = _ref21.rootState,
          state = _ref21.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return new DashboardApi(this.$axios).getTableWorkAdmin(_extends({
                idChannel: data.idChannel || -1,
                idTeam: data.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context8.sent;

              commit("setTableWorkData", response);

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getTableWorkAdmin(_x15, _x16) {
      return _ref22.apply(this, arguments);
    }

    return getTableWorkAdmin;
  }(),
  getTableProcessSupervisor: function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref23, data) {
      var commit = _ref23.commit,
          rootState = _ref23.rootState,
          state = _ref23.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return new DashboardApi(this.$axios).getTableProcessSupervisor(_extends({
                idTeam: rootState.user.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context9.sent;

              commit("setTableProcessData", response);

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function getTableProcessSupervisor(_x17, _x18) {
      return _ref24.apply(this, arguments);
    }

    return getTableProcessSupervisor;
  }(),
  getTableWorkSupervisor: function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref25, data) {
      var commit = _ref25.commit,
          rootState = _ref25.rootState,
          state = _ref25.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return new DashboardApi(this.$axios).getTableWorkSupervisor(_extends({
                idTeam: rootState.user.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context10.sent;

              commit("setTableWorkData", response);

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getTableWorkSupervisor(_x19, _x20) {
      return _ref26.apply(this, arguments);
    }

    return getTableWorkSupervisor;
  }(),
  getTableProcessSeller: function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref27, data) {
      var commit = _ref27.commit,
          rootState = _ref27.rootState,
          state = _ref27.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return new DashboardApi(this.$axios).getTableProcessSeller(_extends({
                term: state.search.term,
                idSeller: rootState.user.userId || -1
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context11.sent;

              commit("setTableProcessData", response);

            case 4:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getTableProcessSeller(_x21, _x22) {
      return _ref28.apply(this, arguments);
    }

    return getTableProcessSeller;
  }(),
  getTableWorkSeller: function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref29, data) {
      var commit = _ref29.commit,
          rootState = _ref29.rootState,
          state = _ref29.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return new DashboardApi(this.$axios).getTableWorkSeller(_extends({
                term: state.search.term,
                idSeller: rootState.user.userId || -1
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context12.sent;

              commit("setTableWorkData", response);

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getTableWorkSeller(_x23, _x24) {
      return _ref30.apply(this, arguments);
    }

    return getTableWorkSeller;
  }(),
  updateDataByBossAdmin: function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref31, data) {
      var dispatch = _ref31.dispatch;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              dispatch("getTableRanking", data);
              dispatch("getGraphicAdmin", data);
              dispatch("getTableProcessAdmin", data);
              dispatch("getTableWorkAdmin", data);

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function updateDataByBossAdmin(_x25, _x26) {
      return _ref32.apply(this, arguments);
    }

    return updateDataByBossAdmin;
  }(),
  updateDataBySelectSeller: function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref33, data) {
      var dispatch = _ref33.dispatch,
          commit = _ref33.commit;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              dispatch("getTableRanking", data);
              dispatch("getGraphicSupervisor", data);
              dispatch("getTableProcessSupervisor", data);
              dispatch("getTableWorkSupervisor", data);

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function updateDataBySelectSeller(_x27, _x28) {
      return _ref34.apply(this, arguments);
    }

    return updateDataBySelectSeller;
  }(),
  exportPendingTable: function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref35, _ref36) {
      var idBoss = _ref36.idBoss,
          startDate = _ref36.startDate,
          endDate = _ref36.endDate;
      var response;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _objectDestructuringEmpty(_ref35);

              _context15.next = 3;
              return new AffiliationApi(this.$axios).findAffiliationWorkedPendingCrm({ idBoss: idBoss, startDate: startDate, endDate: endDate });

            case 3:
              response = _context15.sent;
              _context15.next = 6;
              return new CollectorsApi(this.$axios).pendingToType(response[0]);

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function exportPendingTable(_x29, _x30) {
      return _ref37.apply(this, arguments);
    }

    return exportPendingTable;
  }(),
  exportTable: function () {
    var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref38, data) {
      var commit = _ref38.commit,
          dispatch = _ref38.dispatch,
          rootState = _ref38.rootState;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.t0 = rootState.user.roleId;
              _context16.next = _context16.t0 === 1 ? 3 : _context16.t0 === 2 ? 3 : _context16.t0 === 3 ? 5 : 7;
              break;

            case 3:
              dispatch("getTable" + data.type + "ExportAdminBoss", data);
              return _context16.abrupt("break", 8);

            case 5:
              dispatch("getTable" + data.type + "ExportSupervisor", data);
              return _context16.abrupt("break", 8);

            case 7:
              dispatch("getTable" + data.type + "ExportSeller", data);

            case 8:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function exportTable(_x31, _x32) {
      return _ref39.apply(this, arguments);
    }

    return exportTable;
  }(),
  getTableProcessExportAdminBoss: function () {
    var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref40, data) {
      var commit = _ref40.commit,
          rootState = _ref40.rootState,
          state = _ref40.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return new DashboardApi(this.$axios).getTableProcessExportAdminBoss(_extends({
                idChannel: data.idChannel || -1,
                idTeam: data.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context17.sent;
              _context17.next = 5;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-in-process"
              });

            case 5:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function getTableProcessExportAdminBoss(_x33, _x34) {
      return _ref41.apply(this, arguments);
    }

    return getTableProcessExportAdminBoss;
  }(),
  getTableWorkExportAdminBoss: function () {
    var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref42, data) {
      var commit = _ref42.commit,
          rootState = _ref42.rootState,
          state = _ref42.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return new DashboardApi(this.$axios).getTableWorkExportAdminBoss(_extends({
                idChannel: data.idChannel || -1,
                idTeam: data.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context18.sent;
              _context18.next = 5;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-worked"
              });

            case 5:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    function getTableWorkExportAdminBoss(_x35, _x36) {
      return _ref43.apply(this, arguments);
    }

    return getTableWorkExportAdminBoss;
  }(),
  getTableProcessExportSupervisor: function () {
    var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref44, data) {
      var commit = _ref44.commit,
          rootState = _ref44.rootState,
          state = _ref44.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return new DashboardApi(this.$axios).getTableProcessExportSupervisor(_extends({
                idTeam: rootState.user.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context19.sent;

              commit("setTableProcessData", response);
              _context19.next = 6;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-in-process"
              });

            case 6:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    function getTableProcessExportSupervisor(_x37, _x38) {
      return _ref45.apply(this, arguments);
    }

    return getTableProcessExportSupervisor;
  }(),
  getTableWorkExportSupervisor: function () {
    var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref46, data) {
      var commit = _ref46.commit,
          rootState = _ref46.rootState,
          state = _ref46.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return new DashboardApi(this.$axios).getTableWorkExportSupervisor(_extends({
                idTeam: rootState.user.idTeam || -1,
                idSeller: data.idSeller || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context20.sent;

              commit("setTableProcessData", response);
              _context20.next = 6;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-worked"
              });

            case 6:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));

    function getTableWorkExportSupervisor(_x39, _x40) {
      return _ref47.apply(this, arguments);
    }

    return getTableWorkExportSupervisor;
  }(),
  getTableProcessExportSeller: function () {
    var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref48, data) {
      var commit = _ref48.commit,
          rootState = _ref48.rootState,
          state = _ref48.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return new DashboardApi(this.$axios).getTableProcessExportSeller(_extends({
                idSeller: rootState.user.userId || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context21.sent;

              commit("setTableProcessData", response);
              _context21.next = 6;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-in-process"
              });

            case 6:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    function getTableProcessExportSeller(_x41, _x42) {
      return _ref49.apply(this, arguments);
    }

    return getTableProcessExportSeller;
  }(),
  getTableWorkExportSeller: function () {
    var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref50, data) {
      var commit = _ref50.commit,
          rootState = _ref50.rootState,
          state = _ref50.state;
      var response;
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return new DashboardApi(this.$axios).getTableWorkExportSeller(_extends({
                idSeller: rootState.user.userId || -1,
                term: state.search.term
              }, setTableParametersOfState(state, data)));

            case 2:
              response = _context22.sent;

              commit("setTableProcessData", response);
              _context22.next = 6;
              return new CollectorsApi(this.$axios).csvModel({
                data: response[0],
                filename: "affiliations-worked"
              });

            case 6:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));

    function getTableWorkExportSeller(_x43, _x44) {
      return _ref51.apply(this, arguments);
    }

    return getTableWorkExportSeller;
  }(),
  getTableBossesChannelById: function () {
    var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref52, data) {
      var commit = _ref52.commit,
          rootState = _ref52.rootState,
          state = _ref52.state;

      var _JSON$parse, response, filename;

      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _JSON$parse = JSON.parse(data), response = _JSON$parse.response, filename = _JSON$parse.filename;
              // commit('setTableProcessData', response)

              _context23.next = 3;
              return new CollectorsApi(this.$axios).csvModel({
                data: response,
                filename: filename
              });

            case 3:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, this);
    }));

    function getTableBossesChannelById(_x45, _x46) {
      return _ref53.apply(this, arguments);
    }

    return getTableBossesChannelById;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/dashboard/table.js
// module id = ./src/store/dashboard/table.js
// module chunks = 34